import { render, staticRenderFns } from "./TableRender.vue?vue&type=template&id=66db072c&"
import script from "./TableRender.vue?vue&type=script&lang=js&"
export * from "./TableRender.vue?vue&type=script&lang=js&"
import style0 from "./TableRender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports